module.exports = __webpack_public_path__ + "5e24a3ab19eea300405ccaca75cc9dad.svg";